module.exports = __webpack_public_path__ + "img/coinbase-wallet.d47bc04b.svg";